import { createBrowserRouter } from 'react-router-dom';
import { PublicRoutes } from './Container';

export const router = createBrowserRouter([PublicRoutes]);